import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import extract from '../../core/extract'
import phonez from '../../core/phonez'
import {infoStatus} from '../../core/redux/status'
import DashboardPanel from '../../core/components/DashboardPanel'
import DashboardPanelAdd from '../../core/components/DashboardPanelAdd'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import {CONTACT_PATRIMONY_LINK_TYPES, Contact} from '../models'
import style from './ContactDashboard.less'

function mediumFilter(type) {
    return (medium) => {
        return medium.contactInfoType == type
    }
}

function linkedWithFilter(linkTypes) {
    return (link) => {
        return linkTypes.find((lt) => link.linkType == lt) != null
    }
}

class ContactDashboard extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, contact} = this.props

        const phoneMediums = contact.contacts.filter(mediumFilter('Phone'))
        const mailMediums = contact.contacts.filter(mediumFilter('Mail'))
        const faxMediums = contact.contacts.filter(mediumFilter('Fax'))
        const primaryLinkedWith = contact.linkedWith.filter(linkedWithFilter(CONTACT_PATRIMONY_LINK_TYPES))

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        return (
            <div>
                <Row>
                    <Col sm={6} md={4}>
                        <DashboardPanel light
                            header={panelHeader(i18n.description)}>
                            <ul className={style.data}>
                                {primaryLinkedWith.map((linkedWith, index) => (
                                    <li key={index}>
                                        <label>> {Contact.extractLinkedWith(i18n.patrimonyContactLinkTypeEnum, linkedWith)} :</label>
                                        {linkedWith.patrimony && (
                                            <span> {linkedWith.patrimony.label}</span>
                                        )}
                                        {linkedWith.patrimony && linkedWith.patrimony.ref && (
                                            <span> ({linkedWith.patrimony.ref})</span>
                                        )}
                                        {linkedWith.lot && (
                                            <span> {linkedWith.lot.ref}</span>
                                        )}
                                    </li>
                                ))}
                                {phoneMediums.length > 0 && (
                                    <li>
                                        <label>> {i18n.phone} :</label>
                                        {phoneMediums.map((medium, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {phonez(medium.phone).format()}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                                {mailMediums.length > 0 && (
                                    <li>
                                        <label>> {i18n.email} :</label>
                                        {mailMediums.map((medium, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {medium.mail}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                                {faxMediums.length > 0 && (
                                    <li>
                                        <label>> {i18n.fax} :</label>
                                        {faxMediums.map((medium, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {phonez(medium.fax).format()}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                                {contact.address && (
                                    <li>
                                        <label>> {i18n.address} :</label>
                                        <span> {contact.address.address.number}</span>
                                        <span> {contact.address.address.street}</span>
                                        <span>, {contact.address.address.zipCode}</span>
                                        <span> {contact.address.address.city}</span>
                                    </li>
                                )}
                            </ul>
                        </DashboardPanel>
                    </Col>
                    <Col sm={6} md={4}>
                        <DashboardPanelAdd 
                            onClick={() => dispatch(infoStatus(i18n.featureNotImplemented))} />
                    </Col>
                </Row>
            </div>
        )
    }
}

ContactDashboard = connect((state) => ({
    contact: state.patrimony.contact.contact
}))(ContactDashboard)

export default ContactDashboard


// WEBPACK FOOTER //
// ./lib/patrimony/components/ContactDashboard.js